import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faHome,
  faReceipt,
  faBoxOpen,
  faUser,
  faGift,
  faPalette,
  faClipboardList,
  faUserCircle,
  faTruck,
  faChevronRight,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { RouterLink, RouterLinkActive } from '@angular/router';
@Component({
  selector: 'app-sidebar',
  imports: [FontAwesomeModule, RouterLink, RouterLinkActive],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
  animations: [
    trigger('labelState', [
      state(
        'normal',
        style({
          width: '0',
          opacity: '0',
          marginLeft: '0',
          overflow: 'hidden',
        }),
      ),
      state(
        'hovered',
        style({
          width: '*',
          opacity: '1',
          marginLeft: '0.5rem',
        }),
      ),
      transition('normal <=> hovered', [animate('200ms ease-out')]),
    ]),
  ],
})
export class Sidebar {
  faHome = faHome;
  faReceipt = faTruck;
  faBoxOpen = faBoxOpen;
  faUser = faUserCircle;
  faGift = faGift;
  faPalette = faPalette;
  faChevronRight = faChevronRight;
  faChevronLeft = faChevronLeft;
  hoveredItem: string | null = null;
  sidebarVisible = true; // <-- new toggle state

  setHovered(item: string | null): void {
    this.hoveredItem = item;
  }

  toggleSidebar(): void {
    this.sidebarVisible = !this.sidebarVisible;
  }
}
